import type { ParsedRecipe } from "@/lib/recipes/import-types";

let importedRecipe: ParsedRecipe | null = null;

export function setImportedRecipe(recipe: ParsedRecipe): void {
  importedRecipe = recipe;
}

export function getImportedRecipe(): ParsedRecipe | null {
  return importedRecipe;
}

export function clearImportedRecipe(): void {
  importedRecipe = null;
}
